<template>
  <div
    class="flex h-full items-center ripple w-full py-3 px-1 mb-2"
    @click="
      $bus.emit($constants.EVENTS.TRANSACTIONS.DETAILS_REQUESTED, $attrs.item)
    "
  >
    <div class="flex items-center gap-4 w-full">
      <!-- icon/logo -->
      <div class="w-14 h-14 rounded-2xl bg-gray-100  shimmerTarget relative flex-shrink-0">
        <ImgComponent
          :src="$attrs.item?.logo"
          alt=""
          class="w-full h-full rounded-xl"
        />
      </div>

      <!-- content -->
      <div class="flex-1 min-w-0">
        <div class="font-semibold text-base shimmerTarget title-color truncate">
          {{ $attrs.item?.operationNameDisplay }}
        </div>
        <div class="description-color shimmerTarget text-sm mt-1">
          {{ $attrs.item?.startDate }}
        </div>
      </div>

      <!-- amount section -->
      <div class="flex flex-col items-end flex-shrink-0">
        <div
          class="flex items-center gap-1.5 font-semibold"
          :class="{
            'text-[#27BE43]': $attrs.item?.operation == 'fund',
            'text-[#FF4F6C]': $attrs.item?.operation == 'withdraw'
          }"
        >
          <svg
            v-if="$attrs.item?.operation == 'fund'"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="flex-shrink-0"
          >
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
          </svg>
          <svg
            v-if="$attrs.item?.operation == 'withdraw'"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="flex-shrink-0"
          >
            <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
            <polyline points="17 18 23 18 23 12" />
          </svg>
          <span class="text-base">{{ $attrs.item?.amountToReceive }}</span>
        </div>
        <div
          class="text-xs font-medium mt-1 px-2 py-0.5 rounded-full"
          :class="{
            'bg-[#27BE43]/10 text-[#27BE43]': $attrs.item?.status == 'success',
            'bg-[#FF4F6C]/10 text-[#FF4F6C]': $attrs.item?.status == 'error',
            'bg-[#ccf]/10 text-[#aac]': $attrs.item?.status == 'pending',
          }"
        >
          {{ $attrs.item?.statusDisplay }}
        </div>
      </div>
    </div>
  </div>
</template>
